import boldtrail from "../Images/Projects/BoldTrail.png"
import insiderealestate from "../Images/Projects/InsideRealestate.png";
import factorybeers from "../Images/Projects/FactoryBeers.png";
import lettherebeneon from "../Images/Projects/lettherebeneon.png";
import urbanlearning from "../Images/Projects/urbanlearning.png";

export const projectsData = [
    {
        id: "boldtrail",
        title: "BoldTrail",
        description: "A high-performance, custom-built WordPress platform engineered from the ground up to maximize search visibility and streamline inbound lead operations. By moving away from bloated off-the-shelf templates, this unique theme balances reliable performance with advanced automation pipelines.",
        image: boldtrail,
        tags: ["Wordpress", "Marketing Site"],
        link: "https://boldtrail.com",
        featured: true,
    },
    {
        id: "ire",
        title: "Inside Real Estate",
        description: "A high-performance enterprise Wordpress site engineered to accelerate the inbound pipeline and maximize AI/organic search visibility.",
        image: insiderealestate,
        tags: ["Wordpress", "Marketing Site"],
        link: "https://insiderealestate.com",
        featured: true,
    },
    {
        id: "factorybeers",
        title: "Factory Brewing Collective",
        description: "A clean, speed-optimized digital presence built from the ground up for a local craft brewery. The entire project was designed around simplicity and frictionless user experience, ensuring that thirsty locals can find what's on tap, or check operating hours.",
        image: factorybeers,
        tags: ["Wordpress", "Marketing Site"],
        link: "https://factorybeers.com",
        featured: true,
    },
    {
        id: "lettherebeneon",
        title: "Let There Be Neon",
        description:  "A high-performance Craft CMS site engineered to show the creative stylings of Let There Be Neon. This site was designed and built to showcase how Let There Be Neon has spent years making the most creative and beautiful neon signs in the US.",
        image: lettherebeneon,
        tags: ["Craft CMS", "Marketing Site"],
        link: "https://lettherebeneon.com",
        featured: false,
    },
    {
        id: "urbanlearning",
        title: "Urban Learning",
        description: "Originally worked with Keith Hille at https://www.hilledesign.com/ to create a new landing page for Urban Learning. This build ended up being much better than what they have been using, pushing them to make it thier homepage. Hopefully this relationship grows into a full website rebuild! Shout out to Keith for the design!",
        image: urbanlearning,
        tags: ["Wordpress", "Marketing Site", "Freelance", "Non Profit"],
        link: "urban-learning.org",
        featured: false,
    }
]